var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25936 0C3.69772 0 0 3.69772 0 8.25936C0 12.821 3.69772 16.5187 8.25936 16.5187C12.821 16.5187 16.5187 12.821 16.5187 8.25936C16.5187 3.69772 12.821 0 8.25936 0ZM12.389 9.0853H9.0853V12.389H7.43343V9.0853H4.12968V7.43343H7.43343V4.12968H9.0853V7.43343H12.389V9.0853Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25936 0C3.69772 0 0 3.69772 0 8.25936C0 12.821 3.69772 16.5187 8.25936 16.5187C12.821 16.5187 16.5187 12.821 16.5187 8.25936C16.5187 3.69772 12.821 0 8.25936 0ZM12.389 9.0853H9.0853V12.389H7.43343V9.0853H4.12968V7.43343H7.43343V4.12968H9.0853V7.43343H12.389V9.0853Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.9dcf336350da8552ce9339176dffac60.svg";
export { ForwardRef as ReactComponent };